import React from 'react';
import { Typography } from '@mui/material';

import { customHeapEvent } from 'utils/heap';

import { PRIME_CDN_URL } from '../../../../constants/environments';

import { IntegrationsCheckboxCard, type IntegrationsCheckboxCardProps } from './IntegrationsCheckboxCard';

const learnMoreUrl = 'https://support.skyslope.com/hc/en-us/articles/26495446741787-Utility-Connect-SkySlope-FAQ';

export function UtilityConnectCheckboxCard(props: IntegrationsCheckboxCardProps) {
  React.useEffect(() => {
    customHeapEvent('Forms - Onboard Modal - Utility Connect Shown');
  }, []);

  return (
    <IntegrationsCheckboxCard {...props}>
      <img
        src={`${PRIME_CDN_URL}/prime/images/UtilityConnectGLogo.svg`}
        id="utilityConnectLogo"
        alt="Utility Connect"
        width="auto"
        height={40}
      />
      <Typography className="text-sm text-left text-grey-800">
        Simplify moving for clients with Utility Connect: one call, all utilities handled stress-free.{' '}
        <a target="_blank" rel="noopener" href={learnMoreUrl}>
          Learn More.
        </a>
      </Typography>
    </IntegrationsCheckboxCard>
  );
}
